module.exports = __webpack_public_path__ + "static/media/sun.896a044e.png";